import { render, staticRenderFns } from "./camere.vue?vue&type=template&id=3c2cfb34&"
import script from "./camere.vue?vue&type=script&lang=js&"
export * from "./camere.vue?vue&type=script&lang=js&"
import style0 from "./camere.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports